import onAll from 'typesaurus/onAll';
import { useEffect, useState } from '../adaptor';
export default function useOnAll(collection) {
    const [result, setResult] = useState(undefined);
    const [error, setError] = useState(undefined);
    const loading = result === undefined && !error;
    const deps = [JSON.stringify(collection)];
    useEffect(() => {
        if (result)
            setResult(undefined);
        return onAll(collection, setResult, setError);
    }, deps);
    return [result, { loading, error }];
}
//# sourceMappingURL=index.js.map